module.exports = __webpack_public_path__ + "static/portfolio-image-3-56cbba78d86427a7a4b0a404869b8397.jpg";